import atmoClient from "@/setup/clients/atmoClient";
import RestClient from "@/api/utils/baseRestClient";

class SampleFlaskRestClient extends RestClient {
  async bulkDestroy(uuids, config) {
    const url = this.buildUrl("bulk_destroy");
    const response = await this.client.post(url, { uuids }, config);
    return this.toCamel(response.data);
  }
  async bulkCreate(form, config) {
    form = this.toSnake([...form]);
    const url = `${this.path}/bulk_create/`;
    const response = await this.client.post(url, form, config);
    return this.toCamel(response.data);
  }
}

export const sampleFlaskRestClient = new SampleFlaskRestClient(
  atmoClient,
  "sampleflasks"
);
